export default {
  ADD_SELECTED_MAP(state, map) {
    state.selectedMap = map
  },
  SET_MAPS(state, maps) {
    state.maps = null
    state.maps = maps
    state.count = state.count + 1
    // alert(state.count)
    localStorage.setItem('maps', JSON.stringify(maps))
    // ถ้าไม่มีเลือกอันแรก
    if (!state.selectedMap) {
      state.selectedMap = maps.features[0]
      localStorage.setItem('selectedMap', JSON.stringify(maps.features[0]))
    }
  },
  ADD_SEARCHED_MAPS(state, map) {
    state.searchedMap = map
  },
  ADD_AQI_DETAIL(state, aqi_detail) {
    state.AQIDetail = aqi_detail
  },
  ADD_VILLAGE_NAME(state, name) {
    state.searchedMap[0].properties.village_name = name
  },
  ADD_SUB_DISTRICT_NAME(state, name) {
    state.searchedMap[0].properties.sub_district_name = name
  },
  SET_DATE_FILTER(state, date, time) {
    state.date_filter_map = date
    state.time_filter_map = time
  }
}
